module.exports = __webpack_public_path__ + "static/img/layer4.199f9570.png";